import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./IcuMian.css";
import icubanner from "../assets/images/icu_banner.png";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import call from "../assets/images/call.png";
import patient from "../assets/images/patient.png";
import ExpertNurses from "../assets/images/ExpertNurses.png";
import CitiesCovered from "../assets/images/CitiesCovered.png";
import SupportAvailable from "../assets/images/SupportAvailable.png";

import icuImage from "../assets/images/icuImage.png";
import homeicuu3 from "../assets/images/homeicuu3.png";

import { useState } from "react";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import { Modal } from "react-bootstrap";
import CountUp from "react-countup";
import Testimonial from "../layout/Home/Testimonial";
import Review from "../layout/Home/Review";
import Faq from "../layout/Home/Faq";

import faqimage from "../assets/images/icu-faq-home.jpg";
import Accordion from "react-bootstrap/Accordion";
import FaqData from "../layout/Faqdata"; 

const steps = [
  {
    id: 1,
    title: "Book Online",
    desc: "Fill the form or call us",
  },
  {
    id: 2,
    title: "Assessment Call",
    desc: "Doctor reviews patient needs",
  },
  {
    id: 3,
    title: "Equipment Setup",
    desc: "Team arrives with all gear",
  },
  {
    id: 4,
    title: "Care Begins",
    desc: "Nurse starts 24/7 care",
  },
];

export default function IcuHome() {
  const [show, setShow] = useState(false);
  return (
    <>
      <Header />

      <div className="icu_banner_sec">
        <div className="row">
          <div className="col-lg-6">
            <div className="text_icu_banner">
              <p className="subtitle_icu_banner">
                India’s Trusted ICU Home Care
              </p>
              <h1 className="heading_icu_banner">
                Complete ICU Setup At <span>Home</span>
              </h1>
              <p className="pera_icu_banner">
                Get professional <a href="">ICU Setup at Home</a>  with hospital-grade medical equipment, certified critical care nurses, oxygen support and ventilator management—all in the comfort of your home.
              </p>
              <div className="icu_banner_btns">
                <div className="icu_at_home_btn">
                  <Link to="/icu-home-assesment">Book Now</Link>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6"
            style={{
              backgroundImage: `url(${homeicuu3})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        </div>
      </div>

      {/* <section className="icusetup_service_sec">
        <div className="container-fluid">
          <div className="section_heading">
            <div className="content_part text-center col-lg-12  col-sm-12 col-12">
              <span className="short_title">Our Services</span>
              <h2>
                What We <span>Provide</span>
              </h2>
              <p>
                Compassionate nursing care, physiotherapy, and bedside
                assistance tailored for patient comfort, recovery, and daily
                healthcare support.
              </p>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="icusetup_outer">
                <h3>
                  <HomeRoundedIcon />
                  Home ICU Setup
                </h3>
                <p>
                  Advanced ICU care in the comfort of your home. Our Home ICU
                  Setup service provides hospital-grade medical equipment,
                  continuous patient monitoring, and skilled healthcare
                  professionals to ensure critical care support without the need
                  for prolonged hospital stays. We create a safe and comfortable
                  recovery environment tailored to your medical needs.
                </p>
                <div className="getstart">
                  <button> <Link to="/icu-home-assesment">Get Started</Link> </button>
                  <div className="call_us">
                    <img src={call} alt="" />
                    <div className="text">
                      <label htmlFor="">Call Us Anytime</label>
                      <p>+91 87399 90555</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="icusetup_outer">
                <h3>
                  <HomeRoundedIcon />
                  Hospital ICU Setup
                </h3>
                <p>
                  Advanced ICU care in the comfort of your home. Our Home ICU
                  Setup service provides hospital-grade medical equipment,
                  continuous patient monitoring, and skilled healthcare
                  professionals to ensure critical care support without the need
                  for prolonged hospital stays. We create a safe and comfortable
                  recovery environment tailored to your medical needs.
                </p>
                <div className="getstart">
                  <button> <Link to="/icu-home-assesment">Get Started</Link> </button>
                  <div className="call_us">
                    <img src={call} alt="" />
                    <div className="text">
                      <label htmlFor="">Call Us Anytime</label>
                      <p>+91 87399 90555</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="icu-section">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Left Image */}
            <div className="col-lg-5">
              <div className="video-box" onClick={() => setShow(true)}>
                <img src={icuImage} alt="ICU Setup" />

                <div className="play-btn">
                  <PlayArrowRoundedIcon />
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-7">
              <div className="right-content">
                <span className="section-tag">Introduction</span>
                <h2>
                  Complete <span>ICU Care</span> , Right at Your Home
                </h2>
                <p>
                  CaresAtHome offers trusted <a href="/icu-installation-at-home">ICU Setup at Home</a>  with experienced critical care professionals, advanced medical equipment, and continuous patient monitoring. Our personalized <a href="/icu-installation-at-home">ICU care services</a> are designed to provide safe, comfortable, and hospital-quality treatment at home, helping patients recover with confidence while giving families complete peace of mind.
                </p>

                <ul className="service-list">
                  <li> Hospital-Grade ICU Equipment</li>
                  <li>Certified Critical Care Experts</li>
                  <li>Continuous Vital Monitoring</li>
                  <li>Customized Patient Care Plans</li>
                  <li>Emergency Medical Support</li>
                  <li>Compassionate Home-Based Critical Care</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="stats-box">
            <div className="stat-item">
              <img src={patient} alt="icu-home-icon-1" />
              <h3>
                <CountUp
                  start={0}
                  end={4985}
                  duration={7}
                  delay={0.5}
                  enableScrollSpy
                  scrollSpyOnce
                />
                <label>+</label>
              </h3>

              <p>Patients Successfully Supported</p>
            </div>

            <div className="stat-item">
              <img src={ExpertNurses} alt="icu-home-icon-2" />
              <h3>
                <CountUp
                  start={0}
                  end={199}
                  duration={7}
                  delay={0.5}
                  enableScrollSpy
                  scrollSpyOnce
                />
                <label>+</label>
              </h3>
              <p>Certified Critical Care Professionals</p>
            </div>

            <div className="stat-item">
              <img src={SupportAvailable} alt="icu-home-icon-3" />
              <h3>24/7</h3>
              <p>Medical Support Available</p>
            </div>

            <div className="stat-item">
              <img src={CitiesCovered} alt="icu-home-icon-4" />
              <h3>Across Jaipur</h3>
              <p>Reliable Home ICU Services</p>
            </div>
          </div>
        </div>
      </section>

      <section className="whychse icu_pg_cont caregiver_why_content">
        <div className="container-fluid">
          <div className="section_heading">
            <div className="content_part text-center col-lg-12  col-sm-12 col-12">
              <span className="short_title">Why Choose Us</span>
              <h2>
                Why Families Trust Our <span>ICU Services</span> at Home
              </h2>
              <p>
               Receive complete <a href="/icu-installation-at-home">ICU Setup at Home in jaipur</a>  with experienced critical care professionals, advanced medical equipment, and personalized treatment plans that ensure safe, comfortable, and continuous healthcare.
              </p>
            </div>
          </div>
          <div className="row g-3">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Certified ICU Professionals</h3>
                <p>
                  Highly trained ICU nurses and healthcare experts with
                  extensive experience in managing critically ill patients.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <LocalOfferOutlinedIcon />
                <h3>24×7 Critical Care</h3>
                <p>
                  Continuous nursing support, patient monitoring, emergency response, and doctor coordination whenever required.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Affordable ICU Solutions</h3>
                <p>
                  Transparent pricing with flexible daily, weekly, and monthly
                  ICU care packages to meet different patient needs.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <AddShoppingCartOutlinedIcon />
                <h3>Advanced Medical Equipment</h3>
                <p>
                  Hospital-grade ICU equipment including oxygen concentrators, ventilators, cardiac monitors, suction machines, BiPAP/CPAP machines & infusion pumps.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="process-section">
        <div className="container-fluid">
          <div className="process-wrapper">
            <div className="section_heading">
              <div className="content_part text-center col-lg-12  col-sm-12 col-12">
                <span className="short_title text-white">Process</span>
                <h2 className="text-white">
                  How It <span>Works</span>
                </h2>
                <p className="text-white">
                  {" "}
                  ICU setup at your home in 4 easy steps
                </p>
              </div>
            </div>

            <div className="steps-row">
              <div className="process-line"></div>

              {steps.map((step) => (
                <div key={step.id} className="step-item">
                  <div className="step-circle">
                    <span>{step.id}</span>
                  </div>

                  <h4>{step.title}</h4>

                  <p>{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section> */}

      <Testimonial />
      {/* <Review /> */}
      {/* <Faq /> */}



         <div className="faq_sec">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="section_heading ">
                          <h4>
                            Frequently Asked <span>Questions </span>
                          </h4>
                        </div>
                        <div className="faq-image">
                          <img src={faqimage} alt="icu-home-faq-img" className="img-fluid" />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="faq-main">
                           <Accordion defaultActiveKey="0">
                              {FaqData
                                .filter((item) => item.page === "icuhome")
                                .map((item, index) => (
                                  <Accordion.Item
                                    eventKey={index.toString()}
                                    key={item.id}
                                  >
                                    <Accordion.Header>{item.title}</Accordion.Header>
                                    <Accordion.Body>{item.content}</Accordion.Body>
                                  </Accordion.Item>
                                ))}
                            </Accordion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

      <Footer />

      {/* Video Modal */}

      <Modal show={show} onHide={() => setShow(false)} centered size="lg">
        <Modal.Body className="p-0">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/-pLqLys71Yg?si=7eex51pxLasjKwAQ"
            title="YouTube video"
            allow="autoplay"
            allowFullScreen
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
